import type { Candidate, CandidateRequestParams } from '../../types';
import { candidatesApi } from '../candidatesApi';
import { useInfiniteRequest } from '@shared/config/query/hooks';
import { keepPreviousData } from '@tanstack/react-query';
import { candidateQueryKeys } from '../queryKeys';

export const useGetCandidates = ({ ...params }: CandidateRequestParams) => {
  return useInfiniteRequest<Candidate>({
    queryKey: candidateQueryKeys.list(params),
    queryFn: ({ pageParam }) =>
      candidatesApi.getCandidates({
        ...params,
        ...pageParam,
      }),
    initialPageParam: {
      perPage: params.perPage,
      page: params.page,
    },
    placeholderData: keepPreviousData,
  });
};
